import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-quick-guide',
  templateUrl: './quick-guide.component.html',
  styleUrls: ['./quick-guide.component.css']
})
export class QuickGuideComponent implements OnInit {
  @Input() data;
  url: string;
  constructor(private modalRef: NgbActiveModal) { }

  ngOnInit() {
    if((this.data.deviceInfo == 'desktop') || (this.data.deviceInfo == 'other')) {
      this.url = 'Harappa_Audio_Response_Guide_Desktop.pdf#zoom=90';
    } else if(this.data.deviceInfo == 'mobile') {
      this.url = 'Harappa_Audio_Response_Guide_Mobile.pdf';
    }
  }

  close(){
    this.modalRef.dismiss();
  }
}
